import React from "react"

export default function OnOff({classes, target, onLabel, offLabel, start})
{       
    const c = classes !== undefined ? ' '+classes : ''
    const s = start !== undefined ? ' '+start : ''
    const labelon = onLabel || 'on'
    const labeloff = offLabel || 'off'

    const handle = (e) =>
    {
        const desc = document.getElementsByClassName(target)[0]
        const handler = e.currentTarget

        if(handler.classList.contains('off'))
        {
            handler.classList.remove('off')   
            handler.classList.add('on')  
            desc.classList.add('on')
            return
        }

        handler.classList.remove('on')   
        handler.classList.add('off')  
        desc.classList.remove('on')

        return
    }

    const status = () =>
    {
        if(start === 'on')
        {
            return 'handler on'+c;
        }
        
        return 'handler off'+c
    }
    
    return (
        <div className={status()} onClick={handle}>
            <div className="off" dangerouslySetInnerHTML={{__html: labelon }}></div>
            <div className="on" dangerouslySetInnerHTML={{__html: labeloff }}></div>
        </div>           
    ) 
}